import { Http } from '../../utils/types'
import { GetBlob, ObjectGeneric } from '../../utils/types/generals'
import { TableResponse } from './reponse'

export const OptionGroupService = (client: Http) => ({
  getOptionGroup: async (query?: string): Promise<TableResponse> => {
    return await client.get(`option-group/detailed${query ? '?' + query : ''}`)
  },
  getOptionGroupById: async (id: number) => await client.get(`option-group/${id}`),
  deleteOptionGroupById: async (id: number) => await client.delete(`option-group/${id}`),
  createOptionGroup: async (body: ObjectGeneric) => await client.post('option-group', body),
  updateOptionGroup: async (body: ObjectGeneric, id: number) => await client.put(`option-group/${id}`, body),
  downloadFile: async (data: {
    type: string
    query?: string
  }): Promise<GetBlob> =>
    await client.getBlob?.(
      `option-group/generate-file${data.query ? '?' + data.query + '&type=' + data.type : '?type=' + data.type}`
    ),
})
